const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-wells/shared/rig/api");